import { PriceFilterRanges } from '../../_constants/price_filter_ranges';
import formatToCurrency from '../../_modules/currency/format_to_currency';

function getPriceOptions(maxPrice, currencyIsoCode, addHigherPrices, noHTML = true) {
    const priceSteps = [];
    const currencyPriceRange = PriceFilterRanges[currencyIsoCode];
    const priceRangeStepCount =  currencyPriceRange.length;

    for (let i = 0; i < priceRangeStepCount; ++i) {
        if (maxPrice >= currencyPriceRange[i]) {
            priceSteps.push([
                String(currencyPriceRange[i]),
                formatToCurrency(currencyPriceRange[i], currencyIsoCode, noHTML)
            ]);
        }
    }

    if (addHigherPrices) {
        if (maxPrice > currencyPriceRange[priceRangeStepCount - 1]) {
            priceSteps.push([
                '20000000',
                '> ' + formatToCurrency(currencyPriceRange[priceRangeStepCount - 1], currencyIsoCode, noHTML)
            ]);
        }
    }

    return priceSteps;
}

export { getPriceOptions };
